import i18n from "@/i18n";
import requireAuthorization from "@/routes/helper/requireAuthorization";
import { PermitionEnum } from "@/components/security/Permitions";

export default [
    {
        path: "/playersReport",
        name: "playersReport",
        component: () => import("@/components/reports/_PlayersReport.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.DownloadReport,
            breadcrumbs: {
                icon: "player-logs-icon",
                paths: []
            },
            title: "reports.playerReportTitle"
        }
    }
];
